import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';

@Component({
  selector: 'app-supervisor-search',
  templateUrl: './supervisor-search.component.html',
  styleUrls: ['./supervisor-search.component.scss'],
})
export class SupervisorSearchComponent implements OnInit {

  constructor(
    private apiConfig: ApiConfiguration,
    private apiService: ApiService,
    private modalController: ModalController
  ) { }


  ngOnInit() { 
    setTimeout(()=>{
      if(this.supervisorData.user_id == 0){
        console.log(this.supervisorData)
        this.emitEvent(this.supervisorData.mobile_no)
      }
    }, 600)
  }

  number = ''
  roleKey
  hideUI: Boolean = true
  hideDetails: Boolean = true
  
  supervisorData: any
  selectedDetails: any = {}
  supervisor: any = [
    {
      "id": 3,
      "role_1": {
        "user_id": 12,
        "mobile": "1111111111",
        "username": "",
        "userole_name": "ZSM"
      },
      "role_2": {
        "user_id": 9,
        "mobile": "2222222220",
        "username": "",
        "userole_name": "ASM"
      },
      "role_3": {
        "user_id": 24,
        "mobile": "3333333330",
        "username": "se one",
        "userole_name": "SE"
      },
      "status": 1,
      "created_date": "2024-08-14 11:30:20",
      "portfolio_id": 1,
      "hierarchy_id": "MA3",
      "program_id": 1
    },
    {
      "id": 4,
      "role_1": {
        "user_id": 12,
        "mobile": "1111111111",
        "username": "",
        "userole_name": "ZSM"
      },
      "role_2": {
        "user_id": 9,
        "mobile": "2222222220",
        "username": "",
        "userole_name": "ASM"
      },
      "role_3": {
        "user_id": 24,
        "mobile": "3333333330",
        "username": "se one",
        "userole_name": "SE"
      },
      "status": 1,
      "created_date": "2024-08-14 11:30:20",
      "portfolio_id": 1,
      "hierarchy_id": "MA5",
      "program_id": 1
    }
  ]



  dissmiss(){
    this.modalController.dismiss();
  }

  selectMapping(e){
    this.modalController.dismiss(e);
  }

  emitEvent(e) {
    if (e.length == '10') {

      this.apiService.get(this.apiConfig.supervisorSearch + `?role_id=${this.supervisorData.role_id}&search=${e}`)
        .subscribe((res: any) => {
          this.supervisor = res.data
          this.roleKey = Object.keys(this.supervisor[0]).find(key =>
            this.supervisor[0][key].userole_name === this.supervisorData.parent_role_short_name
          );
          this.hideUI = false
        }, err => {

        })

    }
  }

  viewSupervisors(s) {
    this.selectedDetails = s
    this.hideDetails = false
  }
  actionHideDetails(){
    this.hideDetails = true
  }

}
